export const HOME_PREFIX = 'home';

export const HOME_QUERY_KEY = {
  LIVE_BROADCAST_LIST: (userId: string) =>
    [HOME_PREFIX, 'liveBroadcastList', userId] as const,
  VOD_LIST: (userId: string) => [HOME_PREFIX, 'vodList', userId] as const,
  HOME_POST_LIST: (userId: string) =>
    [HOME_PREFIX, 'postList', userId] as const,
  HOME_CLIP_LIST: (userId: string) =>
    [HOME_PREFIX, 'clipList', userId] as const,
  HOME_CATCH_LIST: (userId: string) =>
    [HOME_PREFIX, 'catchList', userId] as const,
  BOTTOM_BANNER_LIST: (userId: string) =>
    [HOME_PREFIX, 'bottomBannerList', userId] as const,
  FLOATING_BANNER_LIST: (userId: string) =>
    [HOME_PREFIX, 'floatingBannerList', userId] as const,
  HOME_SECTION_LIST: (userId: string) =>
    [HOME_PREFIX, 'sectionList', userId] as const,
} as const;
